import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';

const ACCENT_ORANGE = '#F59E0B';

/**
 * 근로자 의견 받기 종료 확인
 */
export default function WorkerOpinionReceptionEndModal({
  open,
  onClose,
  onConfirm,
  loading = false,
}) {
  return (
    <Dialog
      open={!!open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2, p: 1 } }}
    >
      <DialogContent sx={{ pt: 3, pb: 1, textAlign: 'center' }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            bgcolor: 'rgba(245, 158, 11, 0.18)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <HighlightOffOutlinedIcon sx={{ fontSize: 32, color: ACCENT_ORANGE }} />
        </Box>
        <Typography variant="h6" fontWeight={800} gutterBottom>
          의견 받기 종료
        </Typography>
        <Typography variant="body2" color="text.secondary">
          근로자 의견 받기 기간을 종료하시겠습니까?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', px: 2, pb: 2.5, pt: 0 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={loading}
          sx={{ textTransform: 'none', fontWeight: 700, minWidth: 100 }}
        >
          취소
        </Button>
        <Button
          variant="contained"
          onClick={async () => {
            const ok = await onConfirm?.();
            if (ok === true) onClose?.();
          }}
          disabled={loading}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            minWidth: 100,
            bgcolor: ACCENT_ORANGE,
            '&:hover': { bgcolor: '#D97706' },
          }}
        >
          종료
        </Button>
      </DialogActions>
    </Dialog>
  );
}
